export function isNativeAndroid() {
  return !!window.VibeNative && typeof window.VibeNative.postMessage === 'function';
}
let nativeSequence = 0;
const nativePending = new Map();
export function requestNative(op, args = {}) {
  if (!isNativeAndroid()) return Promise.reject(new Error('Android bridge unavailable'));
  window.VibeNative.onmessage = event => {
    try {
      const result = JSON.parse(event.data);
      const pending = nativePending.get(result.id);
      if (!pending) return;
      clearTimeout(pending.timer); nativePending.delete(result.id);
      if (result.error) pending.reject(new Error(result.error)); else pending.resolve(result.value);
    } catch (_) { /* Ignore unrelated or malformed replies. */ }
  };
  return new Promise((resolve, reject) => {
    const id = String(++nativeSequence);
    const timer = setTimeout(() => { nativePending.delete(id); reject(new Error('Android не ответил. Попробуйте ещё раз.')); }, 60000);
    nativePending.set(id, {resolve, reject, timer});
    window.VibeNative.postMessage(JSON.stringify({...args, id, op}));
  });
}
export function isIOSDevice() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
export function isInstalledWebApp() {
  return navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
}
export function pushConfigured(config) {
  return !!config && ['apiKey','projectId','appId','messagingSenderId','messagingVapidKey'].every(key => typeof config[key] === 'string' && config[key].trim());
}
// Call directly from the button handler; iOS requires a user gesture.
export function requestNotificationPermission() {
  if (isNativeAndroid()) return requestNative('permission');
  if (isIOSDevice() && !isInstalledWebApp()) return Promise.reject(new Error('На iPhone добавьте Vibe на экран «Домой» и откройте через его значок.'));
  if (!window.isSecureContext || typeof Notification === 'undefined' || !('serviceWorker' in navigator) || !('PushManager' in window)) return Promise.reject(new Error('Фоновые уведомления недоступны. Нужны HTTPS и поддержка Web Push; на iPhone — iOS 16.4 или новее.'));
  if (Notification.permission === 'denied') return Promise.reject(new Error('Уведомления заблокированы. Разрешите их в настройках уведомлений iPhone или браузера.'));
  if (Notification.permission === 'granted') return Promise.resolve('granted');
  return Notification.requestPermission().then(permission => {
    if (permission !== 'granted') throw new Error('Разрешение на уведомления не получено.');
    return permission;
  });
}
